<template>
    <div class="row">
        <div class="col-12 mb-3">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'checkpoints' }">Checkpoints</el-breadcrumb-item>
                <el-breadcrumb-item v-if="$route.params.checkpointId">Edit</el-breadcrumb-item>
                <el-breadcrumb-item v-else>Create</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <tabs>
                    <tab-pane label="General Information">
                        <form class="form-horizontal">
                            <!-- NAME -->
                            <div class="row d-flex align-items-center">
                                <label class="col-sm-2 col-form-label">Name *</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="checkpoint.name"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Description -->
                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label">Description</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="checkpoint.description" type="textarea"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Type -->
                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Type</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio disabled v-model="checkpoint.type" label="unique">Unique</el-radio>
                                        <el-radio disabled v-model="checkpoint.type" label="multiple">Multiple</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label">Success Page Message</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="additionalSettings.successPageMessage"/>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Show Event Logo In Success Page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="additionalSettings.showEventLogo" :label="true">Yes</el-radio>
                                        <el-radio v-model="additionalSettings.showEventLogo" :label="false">No</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Show QR In Success Page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="additionalSettings.showQr" :label="true">Yes</el-radio>
                                        <el-radio v-model="additionalSettings.showQr" :label="false">No</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Show Print Button In Success Page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="additionalSettings.showPrintButton" :label="true">Yes</el-radio>
                                        <el-radio v-model="additionalSettings.showPrintButton" :label="false">No</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Send Confirmation Email Automatically</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="additionalSettings.sendAutoConfirmationEmail" :label="true">Yes</el-radio>
                                        <el-radio v-model="additionalSettings.sendAutoConfirmationEmail" :label="false">No</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Enable Search For External Checkin</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-radio v-model="additionalSettings.enableSearchForExternalCheckin" :label="true">Yes</el-radio>
                                        <el-radio v-model="additionalSettings.enableSearchForExternalCheckin" :label="false">No</el-radio>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">CC Email Address</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="additionalSettings.ccEmail" />
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3 d-flex align-items-center">
                                <label class="col-sm-2 col-form-label p-0">Reply To Email Address</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="additionalSettings.replyToEmail" />
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <label class="col-sm-2 col-form-label">Fields to be shown in checkin page & attendees page</label>
                                <div class="col-sm-10">
                                    <div v-if="checkpoint.fieldsForCheckinAndAttendeesPage.length" class="d-flex justify-content-between list-group-item font-weight-bold">
                                        <div>Title</div>
                                        <!-- <div>Name</div>
                                        <div>Type</div> -->
                                        <div>Actions</div>
                                    </div>
                                    <draggable v-model="checkpoint.fieldsForCheckinAndAttendeesPage">
                                        <transition-group>
                                            <li
                                                v-for="(field, idx) in checkpoint.fieldsForCheckinAndAttendeesPage"
                                                :key="`field-${field._id}`"
                                                class="list-group-item cursor-pointer">
                                                    <div class="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <div>
                                                                <fa icon="bars" class="mr-2"/>
                                                                {{ field.title }}
                                                            </div>

                                                            <label class="d-flex align-items-center mt-2" style="gap: 8px; cursor: pointer;">
                                                                <input v-model="field.pullDataFromPrimaryRegistrant" type="checkbox" :id="`field-${field._id}-${idx}`">
                                                                <span :style="field.pullDataFromPrimaryRegistrant ? 'color: #006dfa;':''">Pull data from primary registrant</span>
                                                            </label>
                                                            <label class="d-flex align-items-center mt-2" style="gap: 8px; cursor: pointer;">
                                                                <input v-model="field.treatAsEmail" :value="true" type="radio" name="treatAsEmail">
                                                                <span>Treat as email</span>
                                                            </label>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <el-tooltip content="Remove" placement="top-start">
                                                                <el-button @click="removeField(field)" size="mini" class="d-flex justify-content-center align-items-center btn-danger" style="border-radius: 999px; height: 30px; width: 30px;">
                                                                    <fa style="height: 10px; width: 10px;"  :icon="['fas', 'trash']" />
                                                                </el-button>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                            </li>
                                        </transition-group>
                                    </draggable>

                                    <div class="d-flex  mt-2">
                                        <el-tooltip content="Add Field" placement="top-start">
                                            <el-button @click="addFieldModalOpen = true">
                                                <div class="d-flex align-items-center" style="gap: 10px;">
                                                    <fa style="height: 10px; width: 10px;"  :icon="['fas', 'plus']" />
                                                    <span>Add Field</span>
                                                </div>
                                            </el-button>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end">
                                <el-button
                                    @click="submit()"
                                    :loading="saving"
                                    type="primary"
                                    class="btn btn-primary">
                                        Save
                                </el-button>
                            </div>
                        </form>
                    </tab-pane>
                </tabs>
            </card>
        </div>

        <el-dialog
            v-if="addFieldModalOpen"
            :visible.sync="addFieldModalOpen"
        >
            <div>
                <div v-if="populatedFields.length" v-for="field in populatedFields" class="d-flex align-items-center mb-2" style="gap: 8px; font-size: 1.1rem;">
                    <input :checked="selectedIds.includes(field._id)" type="checkbox" :id="field._id + 'check'" @change="handleChange($event, field)">
                    <label class="m-0 p-0 cursor-pointer" :for="field._id + 'check'">{{ field.title }}</label>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import CustomSelect from '../../components/CustomSelect.vue'
import http from '../../http'
import { mapState } from 'vuex';
import draggable from 'vuedraggable'

export default {
    components: {
        CustomSelect,
        draggable
    },
    data () {
        return {
            saving: false,
            loading: false,
            checkpoint: {
                name: '',
                description: '',
                type: 'unique',
                fieldsForCheckinAndAttendeesPage: []
            },
            checkpointFields:[],
            addFieldModalOpen: false,
            populatedFields: [],
            selectedIds: [],
            additionalSettings: {}
        }
    },
    async mounted () {
        await this.getData()
        this.populateFields();
    },
    computed:{
        ...mapState(['fields']),
    },
    methods: {
        handleChange(e, field){
            this.removeField(field);
            if(e.target.checked){
                this.checkpoint.fieldsForCheckinAndAttendeesPage.push({
                    _id: field._id,
                    title: field.title,
                    pullDataFromPrimaryRegistrant: field.pullDataFromPrimaryRegistrant
                });
                this.selectedIds.push(field._id);
            }
        },
        submit: async function () {
            try {
                this.saving = true
                this.checkpoint.additionalSettings = this.additionalSettings;
                if (this.$route.params.checkpointId) {
                    await this.$store.dispatch('update', {
                        path: 'checkpoints',
                        id: this.$route.params.checkpointId,
                        data: this.checkpoint
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', {
                        path: 'checkpoints',
                        data: {
                            ...this.checkpoint,
                            eventId: this.$route.params.eventId
                        }
                    })
                    this.$notify('Checkpoint was successfully created!')
                    this.$router.push({ name: 'checkpoints' })
                }
            } catch (e) {
                console.log('error creating new checkpoint')
            }
            this.saving = false
        },
        getData: async function () {
            this.loading = true

            try {
                const res = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`)
                this.checkpointFields = res.data.fields;
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }

            let params = { filters: { eventId: this.$route.params.eventId } }
            if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })

            try {
                if (!this.$route.params.checkpointId) {
                    this.loading = false
                    return
                }

                const response = await this.$store.dispatch('get', { path: 'checkpoints', key: 'checkpoint', id: this.$route.params.checkpointId })
                this.checkpoint = response.data.checkpoint
                if(this.checkpoint.additionalSettings) this.additionalSettings = this.checkpoint.additionalSettings;
            } catch (e) {
                console.log('error getting checkpoint')
            }
            this.loading = false
        },
        removeField(field){
            this.selectedIds = this.selectedIds.filter(el => el != field._id);
            this.checkpoint.fieldsForCheckinAndAttendeesPage = this.checkpoint.fieldsForCheckinAndAttendeesPage.filter(el => el._id != field._id)
        },
        populateFields(){
            this.checkpointFields.forEach(f =>{
                this.populatedFields.push({ ...f, pullDataFromPrimaryRegistrant: false })
            })
            this.fields.forEach(f =>{
                this.populatedFields.push({ ...f, pullDataFromPrimaryRegistrant: false })
            })

            this.checkpoint.fieldsForCheckinAndAttendeesPage.forEach(el =>{
                this.selectedIds.push(el._id)
            })
        }
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    }
}
</script>
